export default __webpack_public_path__ + "static/videoToLife-b7a9076e5686e3b6d22996f8ac661de1.mp4";